import { convertMediaUrlsToArrays } from '@/utils/helper'

export const festivalHeroSectionMediaKeys = [
  'bg_img_url',
  'bg_img_url_desktop',
  'img_url',
  'mini_img_url',
  'bg_anim_url'
]

export const festivalSMExperienceMediaKeys = [
  'media_url',
  'media_thumbnail',
  'play_icon_url',
]

export const valuePropsMediaKeys = ['icon_url']

export const festivalTrustMarkerMediaKeys = [
  'pointer_icon_url',
  'media_url',
  'media_thumbnail',
]

export const festivalServicesMediaKeys = ['image_url']
export const allServicesMediaKeys = ['icon_url']
export const topCategoriesMediaKeys = ['media_url', 'thumbnail']
export const tithiSectionMediaKeys = ['img_url', 'bg_img_url']
export const contentSectionMediaKeys = ['img_url']
export const customPujaStoriesMediaKeys = ['icon_url']

export const mediaKeys = ['media_url_desktop']

export const allMediaKeys = [
  ...festivalHeroSectionMediaKeys,
  ...festivalSMExperienceMediaKeys,
  ...valuePropsMediaKeys,
  ...festivalTrustMarkerMediaKeys,
  ...festivalServicesMediaKeys,
  ...allServicesMediaKeys,
  ...topCategoriesMediaKeys,
  ...tithiSectionMediaKeys,
  ...contentSectionMediaKeys,
]

export const parseDataOnEdit = (sectionResponse: any) => {
  if (!sectionResponse?.data?.data) return sectionResponse?.data?.data
  const sectionType = sectionResponse.data.data?.section_type
  const itemType = sectionResponse.data.data?.item_type
  const data = sectionResponse.data.data.data
  const parsedResponse = {
    ...sectionResponse.data.data,
    target_config: JSON.stringify(
      { ...sectionResponse.data.data.target_config },
      null,
      '\t',
    ),
  }

  if (sectionType === 'static_ui') {
    switch (itemType) {
      case 'festival_hero_section':
        return {
          ...parsedResponse,
          data: convertMediaUrlsToArrays(data, festivalHeroSectionMediaKeys),
        }
      case 'festival_sm_experience':
        return {
          ...parsedResponse,
          data: convertMediaUrlsToArrays(data, festivalSMExperienceMediaKeys),
        }
      case 'value_props':
        return {
          ...parsedResponse,
          data: convertMediaUrlsToArrays(data, valuePropsMediaKeys),
        }
      case 'festival_trust_marker':
        return {
          ...parsedResponse,
          data: convertMediaUrlsToArrays(data, festivalTrustMarkerMediaKeys),
        }
      case 'festival_services':
        return {
          ...parsedResponse,
          data: convertMediaUrlsToArrays(data, festivalServicesMediaKeys),
        }
      case 'all_services':
        return {
          ...parsedResponse,
          data: convertMediaUrlsToArrays(data, allServicesMediaKeys),
        }
      case 'top_categories_static':
        return {
          ...parsedResponse,
          data: convertMediaUrlsToArrays(data, topCategoriesMediaKeys),
        }
      case 'tithi_section':
        return {
          ...parsedResponse,
          data: convertMediaUrlsToArrays(data, tithiSectionMediaKeys),
        }
      case 'content_section':
        return {
          ...parsedResponse,
          data: convertMediaUrlsToArrays(data, contentSectionMediaKeys),
        }
      default:
        return parsedResponse
    }
  }

  switch (data?.type) {
    case 'info_media':
      const infoMedia =
        data?.info_media?.map((item: any) => ({
          ...item,
          media_url: [item?.media_url],
          thumbnail: [item?.thumbnail],
          target_config: JSON.stringify(item?.target_config, null, '\t'),
        })) || []
      return {
        ...parsedResponse,
        data: { ...data, info_media: infoMedia },
      }

    case 'info_media_web':
      const infoMediaWeb = {
        title: data?.info_media_web?.title,
        sub_title: data?.info_media_web?.sub_title,
        media_list:
          data?.info_media_web?.media_list?.map((item: any) => ({
            ...item,
            media_url: [item?.media_url],
            thumbnail: [item?.thumbnail],
            target_config: JSON.stringify(item?.target_config, null, '\t'),
          })) || [],
      }
      return {
        ...parsedResponse,
        data: { ...data, info_media_web: infoMediaWeb },
      }

    case 'previous_pooja_media':
      const previousMedia =
        data?.media_cards?.map((item: any) => ({
          ...item,
          media: {
            ...item?.media,
            media_url: [item?.media?.media_url],
            media_thumbnail: [item?.media?.media_thumbnail],
          },
        })) || []
      return {
        ...parsedResponse,
        data: { ...data, media_cards: previousMedia },
      }

    case 'banner_items':
      const poojaItems =
        data?.pooja_items?.map((item: any) => ({
          ...item,
          media_url: [item?.media_url],
        })) || []
      const offeringItems =
        data?.offering_items?.map((item: any) => ({
          ...item,
          media_url: [item?.media_url],
        })) || []
      return {
        ...parsedResponse,
        data: {
          ...data,
          pooja_items: poojaItems,
          offering_items: offeringItems,
        },
      }

    case 'today_importance':
      const todayImportance = {
        ...data?.today_importance,
        media: {
          ...data?.today_importance?.media,
          media_url: [data?.today_importance?.media?.media_url],
        },
      }
      return {
        ...parsedResponse,
        data: { ...data, today_importance: todayImportance },
      }

    case 'srimandir_services':
      const srimandirServices =
        data?.srimandir_services?.map((item: any) => ({
          ...item,
          media: {
            ...item?.media,
            media_url: [item?.media?.media_url],
            media_type: [item?.media?.media_type],
          },
          icon_url: [item?.icon_url],
        })) || []
      return {
        ...parsedResponse,
        data: { ...data, srimandir_services: srimandirServices },
      }

    case 'glimpses_of_services':
      const glimpsesOfServices =
        data?.media_cards?.map((item: any) => ({
          ...item,
          media: {
            ...item?.media,
            media_url: [item?.media?.media_url],
            media_thumbnail: [item?.media?.media_thumbnail],
          },
        })) || []
      return {
        ...parsedResponse,
        data: { ...data, media_cards: glimpsesOfServices },
      }

    case 'associated_temples':
      const associatedTemples =
        data?.media_cards?.map((item: any) => ({
          ...item,
          media: {
            ...item?.media,
            media_url: [item?.media?.media_url],
          },
        })) || []
      return {
        ...parsedResponse,
        data: { ...data, media_cards: associatedTemples },
      }

    case 'associated_pilgrims':
      const associatedPilgrims =
        data?.media_cards?.map((item: any) => ({
          ...item,
          media: {
            ...item?.media,
            media_url: [item?.media?.media_url],
          },
        })) || []
      return {
        ...parsedResponse,
        data: { ...data, media_cards: associatedPilgrims },
      }

    case 'previous_order_recommendation_card':
      const previousOrder =
        data?.banner_large_items?.map((item: any) => ({
          ...item,
          media: {
            ...item?.media,
            media_url: [item?.media?.media_url],
            media_thumbnail: [item?.media?.media_thumbnail],
          },
        })) || []
      return {
        ...parsedResponse,
        data: { ...data, banner_large_items: previousOrder },
      }

    case 'banner_large':
      const bannerLarge =
        data?.banner_large?.map((item: any) => ({
          ...item,
          media: {
            ...item?.media,
            media_url: [item?.media?.media_url],
            media_type: item?.media?.media_type,
          },
        })) || []
      return {
        ...parsedResponse,
        data: { ...data, banner_large: bannerLarge },
      }

    case 'highlighted_pooja':
      const highlightedPooja =
        data?.highlighted_pooja?.map((item: any) => ({
          ...item,
          media: {
            ...item?.media,
            media_url: [item?.media?.media_url],
            media_type: item?.media?.media_type,
          },
        })) || []
      return {
        ...parsedResponse,
        data: { ...data, highlighted_pooja: highlightedPooja },
      }
    case 'puja_stories':
      return {
        ...parsedResponse,
        data: {
          ...data,
          puja_stories: {
            ...data?.puja_stories,
            icon_url: [data?.puja_stories?.icon_url],
          },
        },
      }
    case 'intent_generation_banner':
      return {
        ...parsedResponse,
        data: {
          ...data,
          intent_generation_banner: {
            ...data?.intent_generation_banner,
            stores_list:
              data?.intent_generation_banner?.stores_list?.map(
                (store: any) => ({
                  ...store,
                  media_list:
                    store?.media_list
                      ?.map((item: any) => item?.media_url)
                      ?.filter(Boolean) || [],
                  media_thumbnail:
                    store?.media_list
                      ?.map((item: any) => item?.media_thumbnail)
                      ?.filter(Boolean) || [],
                  media_type: store?.media_list?.[0]?.media_type,
                }),
              ) || [],
          },
        },
      }

    case 'influencer_recommendation_banner':
      return {
        ...parsedResponse,
        data: {
          ...data,
          influencer_recommendation_banner: {
            ...data?.influencer_recommendation_banner,
            icon_url: [data?.influencer_recommendation_banner?.icon_url],
            stores_list:
              data?.influencer_recommendation_banner?.stores_list?.map(
                (store: any) => ({
                  ...store,
                  media_list:
                    store?.media_list
                      ?.map((item: any) => item?.media_url)
                      ?.filter(Boolean) || [],
                  media_thumbnail:
                    store?.media_list
                      ?.map((item: any) => item?.media_thumbnail)
                      ?.filter(Boolean) || [],
                  media_type: store?.media_list?.[0]?.media_type,
                }),
              ) || [],
          },
        },
      }

    default:
      return parsedResponse
  }
}
